module.exports = __webpack_public_path__ + "static/media/pochette.ffdb083b.JPG";